// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__1kEpp","content":"styles_content__hOGrB","row":"styles_row__176vb","footer":"styles_footer__-jF9i","phraseLength":"styles_phraseLength__3aM5l"};